import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import { Modal } from '@els/els-react--modal';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import InstitutionForm from './Components/InstitutionForm';
import { useInstitutionErrorMessage, useLastSelectedInstitution } from './InstitutionHooks';

import '../Login.scss';

const spinnerId = 'InstitutionModalForm';

function InstitutionModal(props) {
  const { isAnonymousUser, errorMessage, cancel, closeModal, init, isLoading, resetState, notifications } = props;
  const lastSelectedInstitution = useLastSelectedInstitution();
  const institutionErrorMessage = useInstitutionErrorMessage(errorMessage);

  const keyUpListener = (e) => {
    if (e && e.keyCode === 27 && isAnonymousUser) {
      cancel();
    }
  };

  useEffect(() => {
    if (isAnonymousUser === false && Auth.isReaxysAllowed()) {
      closeModal();
      return;
    }
    init();
    document.addEventListener('keyup', keyUpListener);
    // eslint-disable-next-line consistent-return
    return () => {
      resetState();
      document.removeEventListener('keyup', keyUpListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      label="Institution Modal"
      onClose={cancel}
      width="26.25rem"
      type="secondary"
      className="login-modal institution-modal"
      shouldPreventClickOverlayToClose>
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <InstitutionForm
        {...props}
        notifications={notifications}
        lastSelectedInstitution={lastSelectedInstitution}
        institutionErrorMessage={institutionErrorMessage}
      />
    </Modal>
  );
}

InstitutionModal.propTypes = {
  isAnonymousUser: PropTypes.bool,
  errorMessage: PropTypes.string,
  cancel: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  resetState: PropTypes.func.isRequired,
  notifications: PropTypes.object,
};

export default InstitutionModal;
